import logoBlackSvg from "../assets/images/logo_black.svg";

import "../assets/css/product.scss";

function Footer() {
  return (
    <div className="product-footer">
      <ul>
        <li>
          <div className="logo">
            <img src={logoBlackSvg} alt="" />
          </div>
          <ul>
            <li>상호&nbsp;|&nbsp;(주)동아이지에듀</li>
            <li>
              <a
                href="https://kidsdonga.com/application/service.html"
                target="_blank"
                rel="noreferrer"
              >
                이용약관
              </a>
              &nbsp;|&nbsp;
              <a
                href="https://kidsdonga.com/application/privacy.html"
                target="_blank"
                rel="noreferrer"
              >
                개인정보처리방침
              </a>
            </li>
          </ul>
          <ul>
            <li>대표자 성명&nbsp;|&nbsp;홍성철</li>
            <li>청소년보호책임자&nbsp;|&nbsp;김동열</li>
          </ul>
          <ul>
            <li>
              사업장 소재지(도로명주소)&nbsp;|&nbsp;서울특별시 서대문구 충정로
              35-17, 2층 (충정로3가, 충정로 제2빌딩)
            </li>
            <li>사업자등록번호&nbsp;|&nbsp;110-81-85168</li>
            <li>대표전화&nbsp;|&nbsp;02-362-5108</li>
            <li>팩스&nbsp;|&nbsp;02-362-5113</li>
          </ul>
          <ul>
            <li>
              제호&nbsp;|&nbsp;어린이동아&nbsp;&nbsp;&nbsp;발행·편집인&nbsp;|&nbsp;홍성철
            </li>
          </ul>
          <ul>
            <li>통신판매업등록번호&nbsp;|&nbsp;2011-서울서대문-0248</li>
          </ul>
        </li>
        <li>Copyright by 어린이동아 All rights reserved</li>
      </ul>
    </div>
  );
}

export default Footer;
